import { format } from 'date-fns'
import './FlagsTable.css'

function FlagsTable({ flags, totalFlags, onFlagClick }) {
  const formatCategory = (cat) => {
    return cat.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const formatStatus = (status) => {
    return status.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  return (
    <div className="flags-table">
      <div className="flags-table-header">
        <h2>Flags</h2>
        <div className="results-count">
          Showing {flags.length} of {totalFlags}
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Category</th>
            <th>Severity</th>
            <th>Reporter</th>
            <th>Department</th>
            <th>Status</th>
            <th>Summary</th>
          </tr>
        </thead>
        <tbody>
          {flags.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
                No flags match the current filters
              </td>
            </tr>
          ) : (
            flags.map(flag => (
              <tr key={flag.flagId} onClick={() => onFlagClick(flag.flagId)}>
                <td>
                  {format(new Date(flag.createdAt), 'dd MMM yyyy')}
                </td>
                <td>{formatCategory(flag.category)}</td>
                <td>
                  <span className={`badge badge-${flag.severity}`}>
                    {flag.severity.toUpperCase()}
                  </span>
                </td>
                <td>
                  {flag.isAnonymous ? (
                    <span className="badge badge-anonymous">Anonymous</span>
                  ) : (
                    flag.userName || flag.userEmail
                  )}
                </td>
                <td>{flag.department || 'Unknown'}</td>
                <td>
                  <span className={`badge badge-${flag.status}`}>
                    {formatStatus(flag.status).toUpperCase()}
                  </span>
                </td>
                <td>
                  <div className="summary-preview" title={flag.summary}>
                    {flag.summary}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}

export default FlagsTable

